import { inject, Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly oidcSecurityService = inject(OidcSecurityService);

  configuration$ = this.oidcSecurityService.getConfiguration();

  userData$ = this.oidcSecurityService.userData$;

  cognitoDomain = environment.cognitoDomain;
  cognitoClientId = environment.cognitoAppClientId;
  cognitoSignOutUrl = environment.cognitoSignOutUrl;
  constructor(private http: HttpClient,
    private userService: UserService,
    private router: Router
  ) { }


  isAuthenticated(): Observable<any> {
    return this.oidcSecurityService.isAuthenticated()
  }
  checkAuth(): Observable<any> {
    
    return this.oidcSecurityService.checkAuth()
  }
  getAccessToken() {
    if (this.oidcSecurityService.getAccessToken()) {
      return this.oidcSecurityService.getAccessToken()
    }
    this.router.navigate(['/403']);
    return this.oidcSecurityService.getAccessToken()
  }
  login(): void {
    this.oidcSecurityService.authorize();
  }

  logout(): void {
    // Limpiar estado local antes de redirigir
    this.userService.removeUser();
    localStorage.clear();
    sessionStorage.clear();

    // Construir URL de logout de Cognito de forma explícita
    const domain = environment.cognitoDomain.replace(/\/+$/, '');
    const clientId = environment.cognitoAppClientId;
    const signOutUrl = environment.cognitoSignOutUrl;
    const logoutUrl = `${domain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(signOutUrl)}`;

    window.location.href = logoutUrl;
  }
}
